import liquidLevel_icon from "@/images/service/liquidLevel_icon.png";
import { useUserInfo } from "@/model";
import { useEffect, useState } from "react";
import { serviceApi } from "@/apis";
import { Spin, message } from "antd";
import empty_png from "@/images/empty.png";
import TtsItemInfo from "./ttsItemInfo";
import "./index.less";

const LiquidLevel = () => {
  const userInfo = useUserInfo();
  const [loading, setLoading] = useState(false);
  const [tankList, setTankList] = useState<TTsInfo[]>([]);

  useEffect(() => {
    if (userInfo.curUserInfo?.userCode) {
      setLoading(true);
      serviceApi
        .findTTsByCustomerUserCode({
          customerUserCode: userInfo.curUserInfo.userCode,
        })
        .then((res) => {
          setTankList(res);
        })
        .catch((err) => {
          message.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [userInfo.curUserInfo]);

  return (
    <div className="liquidLevel-wrapper">
      <div className="center-main-title">
        <div className="flex-c-c">
          <img src={liquidLevel_icon} alt="" />
          <h3>液位管理</h3>
        </div>
        <div className="tips">
          <p>* TTS属于监控工具，仅用于查看储罐液位及下订单参考</p>
          <p>* 实际卸货量以合同约定的流量计/地磅为准</p>
        </div>
      </div>
      <Spin spinning={loading}>
        <div className="liquidLevel-content-wrapper">
          {tankList.map((el) => (
            <TtsItemInfo
              ttsInfo={el}
              className={
                tankList.length === 1 ? "content-item isOne" : "content-item"
              }
            />
          ))}
          {!tankList || tankList.length === 0 ? (
            <div className="empty">
              <img src={empty_png} alt="暂无数据" />
              <p>暂无数据</p>
            </div>
          ) : null}
        </div>
      </Spin>
    </div>
  );
};

export default LiquidLevel;
